import axios, { AxiosError } from 'axios';

export  function  setupAPIclient(token?: string) {
    
    const api = 
    axios.create({
        baseURL: 'https://alexios.com.br:9598', // Altere para o domínio
        timeout: 8000,
        headers: { 
            'Authorization': 'Bearer ' + token
        },

    }) 
    api.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            console.error("Erro na requisição:", error.message);
            return 401; // Rejeita corretamente
        }
    );
    return api
}



